import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = "/api";

const TOKEN_KEY = "np_access";
const REFRESH_KEY = "np_refresh";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setTokens = (access, refresh) => {
    if (access) localStorage.setItem(TOKEN_KEY, access);
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
};
export const clearTokens = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

let isRefreshing = false;
let queue = [];

api.interceptors.response.use(
    (r) => r,
    async (error) => {
        const original = error.config;
        const url = original?.url || "";
        if (
            error.response?.status === 401 &&
            !original._retry &&
            !url.includes("/auth/login") &&
            !url.includes("/auth/refresh") &&
            !url.includes("/auth/register")
        ) {
            original._retry = true;
            const refresh = localStorage.getItem(REFRESH_KEY);
            if (!refresh) return Promise.reject(error);
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    queue.push({ resolve, reject, config: original });
                });
            }
            isRefreshing = true;
            try {
                const { data } = await axios.post(`${API}/auth/refresh-token`, { refresh_token: refresh });
                setTokens(data.access_token, data.refresh_token);
                queue.forEach(({ resolve, config }) => resolve(api(config)));
                queue = [];
                return api(original);
            } catch (e) {
                clearTokens();
                queue.forEach(({ reject }) => reject(e));
                queue = [];
                return Promise.reject(e);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    }
);

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
